import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

import t from './common/localization';
import EditItemView from './EditItemView';
import vendorsAttributes from './attributes/vendorsAttributes';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, FormControlLabel, Checkbox,
 Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from './attributes/EditAttributesView';
import deviceAttributes from './attributes/deviceAttributes';
import { deviceCategories } from './common/deviceCategories';
import LinkField from './form/LinkField';
import { prefixString } from './common/stringUtils';
import Grid from '@material-ui/core/Grid';
import Styles from '@material-ui/core/styles';
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'flex',
  },
  textField: {
               margin: '4px',
               width: '85%',
    },
   root: {
               padding: '10px',
               margin: '10px',
               marginLeft: '60px',
   },
}));

const VendorPage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();

  return (
    <EditItemView endpoint="vendors" item={item} setItem={setItem}>
      {item &&
        <>
     <div className={classes.root}>
     <Grid container spacing={3}>
       <Grid item xs={8}>
         <Paper elevation={3} >
         <Accordion defaultExpanded>
           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
             <Typography variant="subtitle1">
              {t('sharedRequired')}
             </Typography>
           </AccordionSummary>
           <AccordionDetails className={classes.details}>
           <Grid container spacing={3}>
             <Grid item xs={6}>
             <TextField className={classes.textField}
                         margin="normal"
                         InputProps={{ disableUnderline: true }}
                         value={item.name || ''}
                         onChange={event => setItem({...item, name: event.target.value})}
                         label={t('sharedName')}
                         variant="standard" />
                         </Grid>
                <Grid item xs={6}>
               <TextField className={classes.textField}
                margin="normal"
                InputProps={{ disableUnderline: true }}
                value={item.helpline || ''}
                onChange={event => setItem({...item, helpline: event.target.value})}
                label={t('helpline')}
                variant="standard" />
                </Grid>
                 <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.address || ''}
                                                         onChange={event => setItem({...item, address: event.target.value})}
                                                         label={t('address')}
                                                         variant="standard" />
                                                         </Grid>

                                                        <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.website || ''}
                                                         onChange={event => setItem({...item, website: event.target.value})}
                                                         label={t('website')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.banner || ''}
                                                         onChange={event => setItem({...item, banner: event.target.value})}
                                                         label={t('banner')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.logo || ''}
                                                         onChange={event => setItem({...item, logo: event.target.value})}
                                                         label={t('logo')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.tagline || ''}
                                                         onChange={event => setItem({...item, tagline: event.target.value})}
                                                         label={t('tagline')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                          <FormControlLabel
                                                                         control={
                                                                          <Checkbox
                                                                          color="primary"
                                                                           checked={item.distributor}
                                                                           onChange={event => setItem({...item, distributor: event.target.checked})}
                                                                           />
                                                                           }
                                                                                           label={t('distributor')} />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.email || ''}
                                                         onChange={event => setItem({...item, email: event.target.value})}
                                                         label={t('userEmail')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.accountEmail || ''}
                                                         onChange={event => setItem({...item, accountEmail: event.target.value})}
                                                         label={t('accountEmail')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.remarks || ''}
                                                         onChange={event => setItem({...item, remarks: event.target.value})}
                                                         label={t('reportRemarks')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.code || ''}
                                                         onChange={event => setItem({...item, code: event.target.value})}
                                                         label={t('vendorCode')}
                                                         variant="standard" />
                                                         </Grid>
                                                         </Grid>
             </AccordionDetails>
            </Accordion>
            </Paper>
            </Grid>
         <Grid item xs={4}>
         <Paper elevation={3} >
             <Accordion defaultExpanded>
             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {t('sharedAttributes')}
              </Typography>
             </AccordionSummary>
             <AccordionDetails className={classes.details}>
                           <EditAttributesView
                             attributes={item.attributes}
                             setAttributes={attributes => setItem({...item, attributes})}
                             definitions={vendorsAttributes}
                             />
         </AccordionDetails>
         </Accordion>
         </Paper>
         </Grid>
         </Grid>
        </div>
        </>
      }
    </EditItemView>
  );
}

export default VendorPage;
